import styled from 'styled-components';

export const Panel = styled.div`
  background: #091413;
  border-radius: 11px;
  padding: 12px;
`;

export const SbInfo = styled.div`
  position: relative;
  align-self: flex-start;
  margin-bottom: 4px;
`;

export const InfoDot = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #c8a060;
  font-family: var(--head);
  font-weight: 700;
  font-size: 15px;
  font-style: italic;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: help;
`;

export const InfoPop = styled.div`
  position: absolute;
  bottom: 20px;
  top: auto;
  left: 32px;
  right: 0;
  width: auto;
  background: #091413;
  border: 1px solid #25382f;
  border-radius: 12px;
  padding: 16px 17px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.6);
  opacity: 0;
  visibility: hidden;
  transform: translateY(6px);
  transition: all 0.18s;
  z-index: 120;
  pointer-events: none;

  ${SbInfo}:hover & {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  h3 {
    font-family: var(--head);
    font-weight: 600;
    font-size: 17px;
    color: #f0e8d8;
    margin-bottom: 7px;
  }

  p {
    font-size: 12.5px;
    line-height: 1.5;
    color: #b9cabb;
    margin-bottom: 0;
  }
`;

export const WheelWrap = styled.div`
  position: relative;
  width: 265px;
  max-width: 100%;
  margin: 2px auto 0;
  display: block;
`;

export const WheelPointer = styled.div`
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 18px solid #ff7a10;
  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.5));
  z-index: 3;
`;

export const WheelSvg = styled.svg`
  display: block;
  width: 100%;
  transition: transform 2.6s cubic-bezier(0.17, 0.67, 0.21, 0.99);
`;

export const SpinButton = styled.button`
  width: 100%;
  margin-top: 10px;
  padding: 9px 0;
  background: #ff7a10;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  font-family: var(--body);
  transition: background 0.15s;

  &:hover {
    background: #ff8c2e;
  }
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const TodayQ = styled.div<{ $bg: string }>`
  margin-top: 9px;
  background: ${({ $bg }) => $bg};
  border-radius: 9px;
  padding: 9px 11px;
  transition: background 0.3s;
`;

export const TqLbl = styled.div<{ $color: string }>`
  font-size: 10px;
  font-weight: 700;
  color: ${({ $color }) => $color};
  letter-spacing: 1px;
  margin-bottom: 6px;
  text-transform: uppercase;
`;

export const TqTxt = styled.div<{ $color: string }>`
  font-size: 15px;
  font-weight: 600;
  color: ${({ $color }) => $color};
  line-height: 1.4;
`;

export const TqFrom = styled.div<{ $color: string }>`
  font-size: 10px;
  color: ${({ $color }) => $color};
  margin-top: 7px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SpinDup = styled.div`
  margin-top: 7px;
  background: #3a2a14;
  border: 1px solid #5a4220;
  border-radius: 8px;
  padding: 7px 9px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SpinDupTxt = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #f5dca0;
  line-height: 1.3;
  text-align: center;
`;

export const SpinDupBtn = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(245, 220, 160, 0.4);
  color: #f5dca0;
  border-radius: 6px;
  padding: 6px 9px;
  font-weight: 700;
  font-size: 11px;
  cursor: pointer;
  font-family: var(--body);
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }
`;

export const SpinActions = styled.div`
  margin-top: 7px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SaWork = styled.button`
  border: none;
  border-radius: 8px;
  padding: 9px 9px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  font-family: var(--body);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.15s;
  text-align: center;
  line-height: 1.2;
  background: #1e2a26;
  color: #bfe3c8;
  border: 1px solid #2c4a3c;

  &:hover {
    background: #26352f;
  }
`;

export const SaHint = styled.div`
  font-size: 10.5px;
  color: #5a7060;
  text-align: center;
  line-height: 1.3;
  margin-top: 1px;
`;
